<template>
  <div class="main">
    <AllHeader title="成长历程"></AllHeader>
    <div class="wrapper">
      <Gywm title="成长历程"></Gywm>
    </div>
  </div>
</template>
<script>
import AllHeader from "@/components/AllHeader.vue";
import Gywm from "@/components/GywmContent.vue";
import Bus from "@/utils/bus.js";
export default {
  data() {
    return {
    };
  },
  mounted() {
    // window.scrollTo(0, 0);
  },
  methods: {
    
  },
  components: {
    AllHeader,Gywm
  }
};
</script>
<style lang="less" scoped>
.main {
  width: 100%;
  margin-top: 20px;
  .wrapper {
    width: 95%;
    margin: 30px auto;
    .content {
      width: 100%;
      line-height: 1.5;
      color: #000;
    }
  }
}
</style>